import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'

const RectangleIcon = (props) => {
    return (
        <Icon viewBox="0 0 1 30" data-testid="vertical-line-icon" {...props}>
            <line
                x1="0.5"
                y1="0"
                x2="0.5"
                y2="50"
                stroke="currentColor"
                strokeWidth={remCalc(1)}
                fill="none"
            />
        </Icon>
    )
}

RectangleIcon.propTypes = {
    color: PropTypes.string,
}

export default RectangleIcon
